import TextControls from './TextControls';

/**
 * The closest fit bounds for the text without drop shadow
 */
export default class TextInnerControls extends TextControls {
  getX() {
    const { x, foreground, textHighlight } = this.textObject;
    return x + (textHighlight.renderable ? textHighlight.x : foreground.x);
  }

  getY() {
    const { y, foreground, textHighlight } = this.textObject;
    return y + (textHighlight.renderable ? textHighlight.y : foreground.y);
  }

  getWidth() {
    const { foreground, textHighlight } = this.textObject;
    if (textHighlight.renderable) {
      return textHighlight.width;
    }
    return foreground.text ? foreground.width : 0;
  }

  getHeight() {
    const { foreground, textHighlight } = this.textObject;
    if (textHighlight.renderable) {
      return textHighlight.height;
    }
    return foreground.text ? foreground.height : 0;
  }
}
